import styled from 'styled-components';

export const Tab = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 8px 25px;
  border: 2px solid ${props => (props.selected ? '#081133' : '#e0e0e0')};
  border-radius: 8px;
  background-color: ${props => (props.selected ? '#669900' : '#fff')};
  border-color: ${props => (props.selected ? '#89c60e' : '#e0e0e0')};
  color: ${props => (props.selected ? '#fff !important' : '#333')};
  cursor: pointer;
  font-size: 1.1rem;
  min-width: 150px;
  text-transform: uppercase;
  font-weight: bold;

  &:hover {
    border-color: #081133;
  }
`;

export const TabsContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 1rem;
`;

export const Content = styled.div`
  padding: 1rem;
`;


export const ButtonCallToAction = styled.button`
  border: 0;
  outline: 0;
  color: #FFF;
  font-size: 1.1em;
  font-weight: bold;
  padding: 0.5em 2.5em;
  border-radius: 1em;
  transition: transform 200ms ease;
  will-change: transform;
  width: 300px;
  margin: 5px auto;
  margin-bottom: 20px;
  justify-content: center;
  align-items: center;
  gap: 6px;
  display: flex;

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const BackButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  border-radius: 50%;
  background-color: #000000;
  border: 2px solid #ffffff;
  cursor: pointer;
  padding: 0;
  margin-bottom: 15px;
  transition: all 0.2s ease;
  outline: none;
  margin-left: 1em;

  &:hover {
    background-color: #1a1a1a;
    border-color: #ffffff;
  }

  &:active {
    transform: scale(0.95);
  }

  svg {
    color: #ffffff;
    width: 30px;
    height: 30px;
  }
`